<button
  nz-dropdown
  [nzDropdownMenu]="userMenu"
  nzTrigger="click"
  type="button"
  class="user-menu-trigger"
  [class.user-menu-trigger--open]="userMenuOpen()"
  [nzVisible]="userMenuOpen()"
  (nzVisibleChange)="onUserMenuOpenChange($event)"
  [attr.aria-expanded]="userMenuOpen()"
  [attr.aria-label]="'Abrir menu do usuário: ' + (userName() || 'Usuário')"
  [title]="userName() || 'Usuário'"
>
  <nz-avatar class="user-menu-trigger__avatar user-menu-trigger__avatar--icon" nzIcon="user" [nzSize]="32" />
  <nz-avatar class="user-menu-trigger__avatar user-menu-trigger__avatar--initial" [nzText]="userInitial()" [nzSize]="32" />
  <span class="user-menu-trigger__label">{{ userName() || 'Usuário' }}</span>
  <span nz-icon nzType="down" class="user-menu-trigger__icon"></span>
</button>
<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="onLogout()">
      <span nz-icon nzType="logout"></span>
      <span>Sair do sistema</span>
    </li>
  </ul>
</nz-dropdown-menu>
